export default {
  title: "Image de l'offre",
  select: {
    generate_title: "Générer une image avec l'IA",
    generate_subtitle: 'Nous en créerons une basée sur les détails de votre offre.',
    generate_cta: 'Générer',
    upload_link: 'ou importer depuis votre appareil',
    rate_limit_company: {
      title: "Nous avons besoin d'un moment",
      description: "Votre restaurant a généré beaucoup d'images cette heure. Réessayez dans {{time}}.",
    },
    rate_limit_offer: {
      title: 'Petite pause',
      description: 'Vous avez essayé cette offre plusieurs fois de suite. Nous serons prêts dans {{time}}.',
    },
  },
  generating: {
    title: 'Génération de votre image…',
    progress: {
      cooking: 'On prépare quelque chose de savoureux…',
      plating: 'Dressage…',
      finishing: 'Ajout des touches finales…',
    },
  },
  preview: {
    alt: "Image d'offre générée",
    hint: "Pas tout à fait ? Régénérez ou continuez pour recadrer l'image.",
    click_to_expand: 'Cliquer pour agrandir',
    regenerate: 'Régénérer',
    continue: "Continuer l'édition",
  },
  toasts: {
    upload_success: 'Image importée avec succès.',
    upload_failed: "Échec de l'importation de l'image.",
    delete_success: 'Image supprimée avec succès.',
    delete_failed: "Échec de la suppression de l'image.",
    generate_success: 'Image générée avec succès.',
    generate_failed: "Échec du démarrage de la génération d'image.",
    generate_timeout: "L'image est en cours de génération. Elle apparaîtra ici quand elle sera prête.",
    rate_limit_company: "Limite horaire d'images atteinte pour ce restaurant. Réessayez dans {{time}}.",
    rate_limit_offer: 'Trop de tentatives pour cette offre — réessayez dans {{time}}.',
  },
  time: {
    seconds_one: '1 seconde',
    seconds_other: '{{count}} secondes',
    minutes_one: '1 minute',
    minutes_other: '{{count}} minutes',
    hours_one: '1 heure',
    hours_other: '{{count}} heures',
  },
};
